<template>
    <div>
        <v-chip color="purple" outlined small label
            style="position: fixed; top: 70px; right: 16px; z-index: 1000;">
            <v-icon left small>mdi-file-code-outline</v-icon>
            FormSubsidioMaternidad.vue
        </v-chip>
        <DialogoComDistrito ref="dialogoCom" />
        <v-overlay :value="loading">
            <v-container fill-height fluid>
                <v-row align="center" justify="center">
                    <v-col cols="12" md="12" class="d-flex row justify-center align-center">
                        <v-img src="@/assets/Logo-bt-06.png" width="480" class="animacion-logo"></v-img>
                    </v-col>
                    <v-progress-circular indeterminate size="84" width="8" color="white"
                        class="animacion-process ma-5"></v-progress-circular>
                </v-row>
            </v-container>
        </v-overlay>
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form name="formSubsidioMaternidad" @submit.prevent="iniciarTramite">
                <v-card class="custom-card " flat>
                    <v-card-text class="ma-0 pa-0">
                        <v-row>
                            <v-card-text class="font-weight-bold text-body-1 black--text">
                                INFORMACIÓN SOBRE HIJO/A
                            </v-card-text>
                        </v-row>
                        <ValidationObserver ref="datosBasicosObserver" v-slot="{ validate, valid }">
                            <v-row class="d-flex flex-column" v-if="(familiaresSubsidios.length !== 0)">
                                <ValidationProvider v-slot="v">
                                    <v-col class="mt-2">
                                        <v-select clearable :items="familiaresSubsidios" v-model="familiarSeleccionado"
                                            return-object chips deletable-chips multiple
                                            :item-text="item => `${item.nombres} ${item.apellido} | DNI: ${item.nrodoc}`"
                                            label="Seleccionar familiar" @change="capturarFamiliares"></v-select>
                                    </v-col>
                                </ValidationProvider>
                            </v-row>
                            <!--  
                            <v-row>
                                <v-col class=" mt-2">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-text-field v-model="afiliado.pad_fechaSentencia" dense
                                            label="Fecha de sentencia de adopción:" value="01/01/1999" type="date"
                                            :error-messages="v.errors[0]"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                             -->
                            <v-row v-for="(hijo, index) in familiar" :key="index">
                                <v-col v-if="index > 0" cols="12" md="12">
                                    <v-divider></v-divider>
                                </v-col>
                                <v-col cols="10" md="10" class="my-2">
                                    <div class="font-weight-bold text-body-2 primary--text">
                                        HIJO/A {{ index + 1 }}
                                    </div>
                                </v-col>
                                <v-col class="d-flex justify-end align-end" v-if="index > 0">
                                    <v-btn fab small @click="eliminarHijo(index)" color="error" outlined
                                        :disabled="(infoFamiliar)">
                                        <v-icon>mdi-delete-outline</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required|minmax:2,50|alpha_spaces" v-slot="v">
                                        <v-text-field dense v-model="hijo.pmh_nombre" label="Nombres"
                                            :error-messages="v.errors[0]" :disabled="(infoFamiliar)"
                                            @input="hijo.pmh_nombre = hijo.pmh_nombre.toUpperCase()">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required|minmax:2,50|alpha_spaces" v-slot="v">
                                        <v-text-field dense v-model="hijo.pmh_apellido" type="text" label="Apellido"
                                            :error-messages="v.errors[0]" :disabled="(infoFamiliar)"
                                            @input="hijo.pmh_apellido = hijo.pmh_apellido.toUpperCase()">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="8" md="6">
                                    <ValidationProvider rules="required|minmax:7,8|numeric" v-slot="v">
                                        <v-text-field dense v-model="hijo.pmh_nroDoc" type="number" hide-spin-buttons
                                            @input="hijo.pmh_nroDoc = hijo.pmh_nroDoc" label="Nro. DNI"
                                            :disabled="(infoFamiliar)" :error-messages="v.errors[0]"
                                            @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="4" md="6">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-select dense v-model="hijo.pmh_sexo" :disabled="(infoFamiliar)"
                                            :items="itemSexo" label="Sexo" :error-messages="v.errors[0]">
                                        </v-select>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-autocomplete dense v-model="familiarOriginal[index].nacionalidad"
                                            @input="selectNacionalidad($event, index)" return-object
                                            :items="nacionalidades" item-value="id" item-text="desnacionalidad"
                                            label="Nacionalidad" :disabled="(infoFamiliar)"
                                            :error-messages="v.errors[0]">
                                        </v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-select dense v-model="familiarOriginal[index].tipnacionalidad"
                                            :error-messages="v.errors[0]" @input="selectTipNacionalidad($event, index)"
                                            :disabled="(infoFamiliar)" :items="tipoNacionalidad" item-value="tna_id"
                                            return-object item-text="tna_destipnac" label="Tipo de nacionalidad">
                                        </v-select>
                                    </ValidationProvider>
                                </v-col>
                                <v-col>
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-text-field v-model="hijo.pmh_fechaNac" :disabled="(infoFamiliar)" dense
                                            label="Fecha de nacimiento:" value="01/01/1999" type="date"
                                            :error-messages="v.errors[0]"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-select v-model="hijo.pmh_hijoFall" :items="hijoFallOptions"
                                            :disabled="(infoFamiliar)" item-text="text" item-value="value"
                                            label="Hijo Fallecido" dense></v-select>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12" v-if="hijo.pmh_hijoFall == 'S'">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-text-field v-model="hijo.pmh_fechaFall" :disabled="(infoFamiliar)" dense
                                            label="Fecha de fallecimiento:" value="01/01/1999" type="date"
                                            :error-messages="v.errors[0]"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-btn @click="addHijo" :disabled="(infoFamiliar)" small :loading="loading"
                                        color="primary lighten-1" class="pa-5" rounded>
                                        <v-icon class='mr-2'>mdi-account-plus-outline</v-icon>
                                        AGREGAR HIJO/A
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12" class="d-flex justify-end">
                                    <v-btn v-if="infoFamiliar" color="primary" elevation="0" class="pa-5"
                                        :loading="loadBtn" @click="habilitarInformacionFam">
                                        <v-icon class="mr-2">mdi-refresh</v-icon>
                                        MODIFICAR INFORMACIÓN
                                    </v-btn>
                                    <v-btn v-else color="primary" elevation="0" class="pa-5" :loading="loadBtn"
                                        :disabled="!valid" @click="validarSubsidio">
                                        <v-icon class="mr-2">mdi-information</v-icon>
                                        VALIDAR INFORMACIÓN
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </ValidationObserver>
                        <v-row>
                            <v-col>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row class="d-flex flex-row justify-center align-center">
                            <v-card-text class="font-weight-bold text-body-1 black--text ">
                                CUENTA DE ACREDITACIÓN
                            </v-card-text>
                        </v-row>
                        <ValidationObserver ref="datosCuentaObserver" v-slot="{ validate, valid }">
                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-alert colored-border color="orange darken-3" border="left" elevation="0" dense
                                        class="rounded-0 font-weight-regular text-body-1 orange--text text--darken-3">
                                        Recordá que debés ser titular de la cuenta
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row v-if="mediosPagos.length !== 0">
                                <v-col cols="12" md="12">
                                    <v-select clearable chips deletable-chips v-model="medioSeleccionado"
                                        label="Seleccione cuenta" return-object
                                        :item-text="item => `CBU: ${item.deb_cbu1}${item.deb_cbu2}`"
                                        :items="mediosPagos" @change="capturarCuenta"></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-text-field dense v-model="afiliado.pmd_nomYApeTitular" type="text"
                                            hide-spin-buttons disabled
                                            @input="afiliado.pmd_nomYApeTitular = afiliado.pmd_nomYApeTitular.toUpperCase()"
                                            label="Titular" :error-messages="v.errors" @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <ValidationProvider rules="required|length:22|numeric" v-slot="v">
                                        <v-text-field dense v-model="afiliado.pmd_cbu" type="number" hide-spin-buttons
                                            @input="afiliado.pmd_cbu = afiliado.pmd_cbu" label="CBU"
                                            :disabled="(infoCuenta)" :error-messages="v.errors"
                                            @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <ValidationProvider rules="required|length:11|numeric" v-slot="v">
                                        <v-text-field dense v-model="afiliado.pmd_cuit" type="number" hide-spin-buttons
                                            :disabled="(infoCuenta)" label="CUIT/CUIL" :error-messages="v.errors"
                                            @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12" class="d-flex justify-end">
                                    <v-btn v-if="infoCuenta" color="primary" elevation="0" class="pa-5"
                                        :loading="loadBtn" @click="habilitarInfoCuenta">
                                        <v-icon class="mr-2">mdi-refresh</v-icon>
                                        MODIFICAR CUENTA
                                    </v-btn>
                                    <v-btn v-else color="primary" elevation="0" class="pa-5" :disabled="!valid"
                                        :loading="loadBtnCuenta" @click="validarCbu">
                                        <v-icon class="mr-2">mdi-information</v-icon>
                                        VALIDAR CUENTA
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </ValidationObserver>
                        <v-row>
                            <v-col>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-card-text class="font-weight-bold text-body-1 black--text ">
                                DOCUMENTACIÓN REQUERIDA:
                            </v-card-text>
                        </v-row>

                        <v-row class="d-flex flex-row align-end justify-center">
                            <v-col v-for="(hijo, index) in familiar" :key="index" class="d-flex justify-center">
                                <InputButtonArchivo @fileSelected="handleFileSelected" op="partidaNacimiento"
                                    label="PARTIDA DE NACIMIENTO"
                                    :subtitle="hijo.pmh_nombre + ' ' + hijo.pmh_apellido" />
                            </v-col>
                            <v-col class="d-flex justify-center">
                                <InputButtonArchivo @fileSelected="handleFileSelected" :subtitle="nombreApellido"
                                    op="comprobanteCbu" label="COMPROBANTE DE CBU" />
                            </v-col>
                        </v-row>


                        <!--  <v-row class="d-flex flex-row align-end justify-start"
                            :class="($vuetify.breakpoint.smAndDown) ? 'justify-center' : 'justify-space-around'">
                            <InputButtonArchivo @fileSelected="handleFileSelected" op="sentenciaAdopcion"
                                label="PARTIDA DE NACIMIENTO" />
                            <InputButtonArchivo @fileSelected="handleFileSelected" op="comprobanteCbu"
                                label="COMPROBANTE DE CBU" />
                        </v-row> -->
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end align-center custom-card-actions-ha">
                        <v-btn color="primary" elevation="0" class="pa-5" :disabled="invalid || !formValid"
                            type="iniciarTramite">
                            <v-icon class="mr-2">mdi-send-outline</v-icon>
                            enviar trámite
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>
import DialogoComDistrito from '@/components/dialogos/DialogoComDistrito.vue'
import DialogoExito from '@/components/dialogos/DialogoExito.vue'
import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapGetters, mapActions } from 'vuex';

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        DialogoComDistrito,
        InputButtonArchivo,
        DialogoExito
    },
    mounted() {
        //this.afiliado.pad_remitirADistrito = this.user.distrito
        this.afiliado.pmd_nroafi = this.nroafi
        this.afiliado.pmd_nomYApeTitular = this.nombreApellido
        if (this.user.cuil) (
            this.afiliado.pmd_cuit = this.user.cuil
        )
    },
    data() {
        return {
            loading: false,
            titulo: '',
            tipo: '',
            width: '',
            icon: '',
            itemSexo: ['F', 'M', 'X'], // item select sexo

            familiar: [
                {
                    pmh_nombre: '',
                    pmh_apellido: '',
                    pmh_fechaNac: '',
                    pmh_nroDoc: '',
                    pmh_tipodoc: '1',
                    pmh_sexo: '',
                    pmh_fechaFall: ''
                }
            ],
            afiliado:
            {
                pmd_nroafi: "",
                pmd_fechaSentencia: "",
                pmd_fechaNac: "",
                pmd_nomYApeTitular: "",
                pmd_cbu: "",
                pmd_cuit: "",
                /*           pad_cuentaCompartida: "N",
                pad_metodoAcreditacion: "D",
                pad_fechaSolicitud: "",
                pad_propietarioCuenta: "A",
                pad_cantHijos: 1,
                pad_otroTitular: "",
                pad_otroCuit: "",
                pad_apoderado: 1,
                pad_tipTitularCheque: "",
                pad_titularCheque: "",
                pad_requisitos: "N",
                pad_remitirADistrito: "",
                pad_observaciones: "" */
            },
            familiarOriginal: [
                {
                    id: '',
                    nroafi: "",
                    nombres: "",
                    apellido: '',
                    sexo: "",
                    tipdoc: 1,
                    nrodoc: "",
                    estadocivil: '',
                    nacionalidad: '',
                    tipnacionalidad: '',
                    tipfamiliar: 3,
                    fecnacim: "",
                    fecfallecido: "",
                    fecestadocivil: "",
                    discapacidad: "",
                    accion: "A"
                }
            ],
            ordenClaves: ['id', 'nroafi', 'apellido', 'nombres', 'sexo', 'tipdoc', 'nrodoc', 'estadocivil', 'nacionalidad', 'tipnacionalidad', 'tipfamiliar', 'fecnacim', 'fecfallecido', 'fecestadocivil', 'discapacidad', 'accion'],

            formValid: false,
            familiarSeleccionado: null,
            medioSeleccionado: null,

            infoFamiliar: false,
            infoCuenta: false,

            loadBtn: false,
            loadBtnCuenta: false,

            hijoFallOptions: [
                { text: 'Si', value: 'S' },
                { text: 'No', value: 'N' },
            ]

        }
    },
    watch: {
        // Watch for changes in familiarSeleccionado
        familiarSeleccionado(newValue) {
            // If familiarSeleccionado is empty (cleared), enable the fields
            if (!newValue || newValue.length === 0) {
                this.infoFamiliar = false;
            }
        },

        'afiliado.pmd_fechaNac'(newDate) {
            this.familiar[0].pmd_fechaNac = newDate;
        },
    },

    methods: {
        ...mapActions('notificaciones', ['showSnack', 'hideSnack']),
        ...mapActions('subsidios', ['solicitarSubsidiosMaternidad', 'validarSubsidioAfiliado']),
        ...mapActions('mediosDePago', ['validarCBU']),

        habilitarInformacionFam() {
            this.infoFamiliar = false
        },
        habilitarInfoCuenta() {
            this.infoCuenta = false
        },
        handleFileSelected() {
            (this.partidaNacimiento.length !== 0) && (this.comprobanteCbu.length !== 0) ? this.formValid = true : this.formValid = false
        },
        selectNacionalidad(value, index) {
            this.$set(this.familiarOriginal, index, {
                ...this.familiarOriginal[index],
                nacionalidad: value.id,
                desnacionalidad: value.desnacionalidad
            });
        },
        selectTipNacionalidad(value, index) {
            this.$set(this.familiarOriginal, index, {
                ...this.familiarOriginal[index],
                tipnacionalidad: value.tna_id
            });
        },
        async validarCbu() {
            this.loadBtnCuenta = true
            const resultado = await this.validarCBU({ cbu: this.afiliado.pmd_cbu })
            if (resultado) this.infoCuenta = true
            this.loadBtnCuenta = false; // Desactivamos el loading al finalizar

        },
        async validarSubsidio() {
            this.loadBtn = true
            const promises = this.familiar.map(familiar => {
                const obj = {
                    nroafi: this.nroafi,
                    tipoSubsidio: 'maternidad',
                    fechaNacimiento: familiar.pmh_fechaNac,
                    dniFamiliar: familiar.pmh_nroDoc,
                    fechaSentencia: '',
                    fechaMatrimonio: ''
                };
                return this.validarSubsidioAfiliado(obj);
            });

            const results = await Promise.all(promises);
            this.loadBtn = false;

            if (!results.every(result => result === true)) {
                this.$refs.dialogoCom.abrirDialog()
            } else {
                this.infoFamiliar = true
                this.mostrarMensaje = true
            }
            this.loadBtn = false
        },
        capturarFamiliares(item) {
            // this.infoFamiliar = item.length > 0
            if (item.length !== 0) {
                if (item.length > this.familiar.length) {
                    this.showSnack({
                        message: 'No se puede insertar hijo, presione en agregar hijo primero',
                        type: '400'
                    });
                    this.familiarSeleccionado = [];
                    return;
                }
                if (item.length > 0) {
                    // Asigna los datos solo si hay suficiente espacio en el array `hijos`
                    item.forEach((familiar, index) => {
                        if (index < this.familiar.length) {
                            // Actualiza solo los objetos ya existentes en `this.hijos`
                            this.$set(this.familiar, index, {
                                ...this.familiar[index],
                                pmh_nombre: familiar.nombres,
                                pmh_apellido: familiar.apellido,
                                pmh_fechaNac: familiar.fecnacim,
                                pmh_tipdoc: '1',
                                pmh_nroDoc: familiar.nrodoc,
                                pmh_sexo: familiar.sexo
                            });

                            // Actualiza también los datos de `familiarOriginal`
                            this.$set(this.familiarOriginal, index, {
                                ...this.familiarOriginal[index],
                                nacionalidad: familiar.nacionalidad, // Actualiza la nacionalidad
                                tipnacionalidad: familiar.tipnacionalidad, // Actualiza el tipo de nacionalidad
                            });
                        }
                    });
                } else {
                    // Si no hay ningún familiar seleccionado, limpia el array `hijos`
                    this.familiar = [];
                }
            }

        },
        capturarCuenta(item) {
            this.infoCuenta = false
            if (item) {
                this.afiliado.pmd_cbu = `${item.deb_cbu1}${item.deb_cbu2}`
                //  this.validarCBU({ cbu: this.afiliado.pad_cbu })
                this.afiliado.pmd_nomYApeTitular = this.nombreApellido
                this.afiliado.pmd_cuit = this.user.cuil
                this.selectedBancoCod = this.codigoBanco
            } else {
                this.afiliado.pmd_cbu = ''
                this.afiliado.pmd_nomYApeTitular = ''
                this.afiliado.pmd_cuit = ''
                this.selectedBancoCod = ''
            }
        },

        formatDate(date) {
            if (!date) return null
            if (date.includes('/')) {
                const [year, month, day] = date.split('/')
                return `${day}-${month}-${year}`
            } else {
                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            }
        },


        handlePaste(e) {
            e.preventDefault();
            this.showSnack({
                message: 'No esta permitido copiar y pegar',
                type: '500'
            })
        },

        obtenerFamiliarOrdenado() {
            return this.familiarOriginal.map(familiar => {
                const familiarOrdenado = {};
                this.ordenClaves.forEach(key => {
                    familiarOrdenado[key] = familiar[key];
                });
                return familiarOrdenado;
            });
        },
        async iniciarTramite() {
            try {
                this.loading = true
                this.familiarOriginal = this.familiarOriginal.map((familiarObj, index) => {
                    if (familiarObj.accion == 'A') {
                        // Obtiene los datos de afiliado y familiar (index usado para recorrer familiar)
                        return {
                            id: 0,
                            nroafi: this.afiliado?.pmd_nroafi || "",
                            apellido: this.familiar[index]?.pmh_apellido || "",
                            nombres: this.familiar[index]?.pmh_nombre || "",
                            sexo: this.familiar[index]?.pmh_sexo || "",
                            tipdoc: this.familiar[index]?.pmh_tipodoc || 1,
                            nrodoc: this.familiar[index]?.pmh_nroDoc || "",
                            estadocivil: "",
                            nacionalidad: familiarObj.nacionalidad || "",
                            tipnacionalidad: familiarObj.tipnacionalidad || "",
                            tipfamiliar: 3,
                            fecnacim: this.familiar[index]?.pmh_fechaNac || "",
                            fecfallecido: "", // Dejar vacío si no se asigna un valor específico
                            fecestadocivil: "", // Asegura que esté vacío
                            discapacidad: "N", // Dejar vacío si no se asigna un valor específico
                            accion: "A"
                        };
                    }
                    // Retorna el objeto original si no cumple con accion === 'A'
                    return familiarObj;
                });

                const result = this.$refs.obs.validate()
                if (result) {
                    const datosOrdenados = this.obtenerFamiliarOrdenado()
                    const formData = new FormData()
                    formData.append('afiliado', JSON.stringify(this.afiliado))
                    formData.append('familiar', JSON.stringify(this.familiar))
                    formData.append('familiarOriginal', JSON.stringify(datosOrdenados))

                    // Contador
                    let archIndex = 1

                    //Recorrer familiar
                    this.familiar.forEach((familiar, index) => {
                        if (this.partidaNacimiento[index]) {
                            formData.append(`archivo${archIndex}`, this.partidaNacimiento[index])
                            archIndex++
                        }
                    })
                    formData.append(`archivo${archIndex}`, this.comprobanteCbu[0])

                    /* 
                    formData.append('archivo1', this.partidaNacimiento[0])
                    formData.append('archivo2', this.comprobanteCbu[0])
                    */
                    /*
                                         const obj = {
                                            afiliado: [this.afiliado],
                                            hijos: this.hijos,
                                            archivo1: this.sentenciaAdopcion,
                                            archivo2: this.comprobanteCbu
                                        } */

                    formData.forEach((value, key) => {
                        console.log(`Campo: ${key}, Valor:`, value);
                    });
                    await this.solicitarSubsidiosMaternidad(formData)

                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }

            } catch (error) {
                console.error("Ocurrió un error durante el proceso:", error);
            } finally {
                this.loading = false
                this.$emit('handleDialog')
            }
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        isObject(value) {
            return (
                typeof value == 'object' &&
                value !== null &&
                !Array.isArray(value)
            )
        },
        addHijo() {

            const obj = {
                pmh_nombre: '',
                pmh_apellido: '',
                pmh_sexo: '',
                pmh_fechaNac: '',
                pmh_tipdoc: '1',
                pmh_nroDoc: '',
            }
            const objFamOrigin = {
                id: '',
                nroafi: "",
                nombres: "",
                apellido: '',
                sexo: "",
                tipdoc: 1,
                nrodoc: "",
                estadocivil: '',
                nacionalidad: '',
                tipnacionalidad: '',
                tipfamiliar: 3,
                fecnacim: "",
                fecfallecido: "",
                fecestadocivil: "",
                discapacidad: "",
                accion: "A"
            }
            this.familiar.push(obj)
            this.familiarOriginal.push(objFamOrigin)
        },

        eliminarHijo(index) {
            this.familiar.splice(index, 1)
            this.familiarOriginal.splice(index, 1)
        },
    },
    computed: {
        ...mapGetters('dataUser', ['partidaNacimiento', 'comprobanteCbu']),
        ...mapGetters('subsidios', ['familiaresSubsidios', 'mediosPagos']),
        ...mapGetters('auth', ['user', 'nroafi', 'isAuthenticated']),
        ...mapGetters('common', ['tipoNacionalidad', 'estadoCivil', 'tiposFamiliares', 'nacionalidades']),

        nombreApellido() {
            return `${this.user.nombres} ${this.user.apellido}`
        }
    },
    props: {
        tipo: {
            type: Number,
            required: true
        },
    }
}
</script>

<style>
/* Aplicamos el estilo para ajustar el tamaño del texto */
.v-list-item__subtitle {
    white-space: normal;
}

.custom-card {
    position: relative;
    height: 100%;
    cursor: default;
    padding-bottom: 80px;
    /* Espacio suficiente para las acciones */
}

.custom-card-actions-ha {
    position: fixed;
    /* Fijo en la parte inferior */
    bottom: 0;
    left: 0;
    right: 0;
    height: 65px;
    /* Ajusta la altura según sea necesario */
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    /* Asegúrate de que esté por encima del contenido */
}
</style>